import { MoneyConnectClientAPI } from "./axios-service-creator";

export const ResearchAPI = {
  getResearchCategory: () => MoneyConnectClientAPI.get("/research/news/category"),
  getResearchList: (payload) => MoneyConnectClientAPI.post("/research/news", payload),
};
